import { useLayoutEffect } from 'react';

// Only the scroll position is session-local. Filters and paging travel in the URL.
export const useMatchingScroll = (key: string, ready: boolean) => {
  useLayoutEffect(() => {
    if (!ready) return;
    const storageKey = `matching-scroll:${key}`;
    let top = 0;
    try {
      const saved = sessionStorage.getItem(storageKey);
      if (saved !== null) top = Number(saved) || 0;
    } catch {
      /* Storage may be unavailable in private browsing. */
    }
    const frame = requestAnimationFrame(() => window.scrollTo(0, top));
    return () => {
      cancelAnimationFrame(frame);
      try {
        sessionStorage.setItem(storageKey, String(window.scrollY));
      } catch {
        /* Optional preference. */
      }
    };
  }, [key, ready]);
};
